"use strict";

exports.__esModule = true;
exports.useOptimizelyFeature = void 0;

var _reactSdk = require("@optimizely/react-sdk");

var _react = require("react");

var _optimizelySdk = require("@chegg/optimizely-sdk");

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var useOptimizelyFeature = function useOptimizelyFeature(featureKey) {
  var _useContext = (0, _react.useContext)(_reactSdk.OptimizelyContext),
      optimizely = _useContext.optimizely;

  var featureDetails = (0, _optimizelySdk.useSafeOptimizelyFeature)(featureKey);
  return _extends({}, featureDetails, {
    optimizely: optimizely
  });
};

exports.useOptimizelyFeature = useOptimizelyFeature;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-web-tools/next-optimizely/dist/helperHooks.js
// module id = 5740
// module chunks = 11